import styles from "./loader.module.css";
export default function Loader({ className, style }) {
  return (
    <div className={`${styles["lds-dual-ring"]} ${className}`} style={style} />
  );
}
